import { render, staticRenderFns } from "./YoutubePlayer.vue?vue&type=template&id=3a3c53cd&scoped=true&"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js&"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js&"
import style0 from "./YoutubePlayer.vue?vue&type=style&index=0&id=3a3c53cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3c53cd",
  null
  
)

export default component.exports